
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.431 2c-.614 0-1.11.447-1.11 1 0 .553.496 1 1.11 1v.344c0 1.325.587 2.597 1.629 3.534L8.414 10 6.06 12.122c-1.042.937-1.629 2.21-1.629 3.534V16c-.614 0-1.11.447-1.11 1 0 .553.496 1 1.11 1h11.112c.614 0 1.11-.447 1.11-1 0-.553-.496-1-1.11-1v-.344c0-1.325-.587-2.597-1.629-3.534L11.56 10l2.357-2.122c1.042-.937 1.629-2.21 1.629-3.534V4c.615 0 1.111-.447 1.111-1 0-.553-.496-1-1.111-1H4.431zm8.89 13.656V16H6.653v-.344c0-.797.35-1.56.975-2.122l2.358-2.118 2.358 2.121c.625.563.975 1.325.975 2.122v-.003z","fill":"#999"}})])
          )
        }
      }
    